import * as ko from 'knockout';
class ResidentMultiSelectViewModel {
    constructor(params) {
        // Actions
        this.openModal = () => {
            console.log(`[RMS-DEBUG][${this.fieldName}] openModal: Opening modal`);
            console.log(`[RMS-DEBUG][${this.fieldName}] openModal: Current selectedResidents for field =`, JSON.stringify((this.formViewModel.selectedResidents()[this.fieldName] || []).map(s => ({ id: s.id, name: s.name }))));
            console.log(`[RMS-DEBUG][${this.fieldName}] openModal: Current customResidents for field =`, JSON.stringify((this.formViewModel.customResidents()[this.fieldName] || []).map(s => ({ id: s.id, name: s.name }))));
            console.log(`[RMS-DEBUG][${this.fieldName}] openModal: Total residents available =`, this.formViewModel.residents().length);
            this.modalVisible(true);
            console.log(`[RMS-DEBUG][${this.fieldName}] openModal: modalVisible is now =`, this.modalVisible());
        };
        this.closeModal = () => {
            console.log(`[RMS-DEBUG][${this.fieldName}] closeModal: Called. About to _applyAndClose()`);
            // Always apply selections when the modal closes, regardless of how it's closed.
            // This ensures that clicking the backdrop, the X button, or "Übernehmen" all persist state.
            this._applyAndClose();
        };
        this.clearAllSelections = (data, event) => {
            event.stopPropagation();
            console.log(`[RMS-DEBUG][${this.fieldName}] clearAllSelections: Called`);
            // Clear selected residents for this field using immutable update
            const selections = Object.assign({}, this.formViewModel.selectedResidents());
            console.log(`[RMS-DEBUG][${this.fieldName}] clearAllSelections: Before clear, selections count=${(selections[this.fieldName] || []).length}`);
            selections[this.fieldName] = [];
            this.formViewModel.selectedResidents(selections);
            // Clear custom residents for this field using immutable update
            const customEntries = Object.assign({}, this.formViewModel.customResidents());
            console.log(`[RMS-DEBUG][${this.fieldName}] clearAllSelections: Before clear, customEntries count=${(customEntries[this.fieldName] || []).length}`);
            customEntries[this.fieldName] = [];
            this.formViewModel.customResidents(customEntries);
            // Update the field value
            this.formViewModel.updateResidentFieldValue(this.fieldName);
            console.log(`[RMS-DEBUG][${this.fieldName}] clearAllSelections: Done. selectionSummary="${this.selectionSummary()}"`);
        };
        /**
         * Check if a resident is selected.
         * IMPORTANT: This method reads `this.formViewModel.selectedResidents()` to
         * establish a Knockout dependency. When used inside a `ko.computed` or a binding
         * that creates a dependency context, changes to `selectedResidents` will cause
         * re-evaluation.
         */
        this.isSelected = (resident) => {
            // Reading the observable here is what makes it reactive.
            const allSelections = this.formViewModel.selectedResidents();
            const fieldSelections = allSelections[this.fieldName] || [];
            const result = fieldSelections.some(r => r.id === resident.id);
            // Note: This fires very often (per-resident), so we only log when selected
            if (result) {
                console.log(`[RMS-DEBUG][${this.fieldName}] isSelected: resident id=${resident.id} name="${resident.name}" => TRUE (fieldSelections count=${fieldSelections.length})`);
            }
            return result;
        };
        // Toggle a resident selection
        this.toggleSelection = (resident) => {
            console.log(`[RMS-DEBUG][${this.fieldName}] toggleSelection: Called for resident id=${resident.id}, name="${resident.name}"`);
            console.log(`[RMS-DEBUG][${this.fieldName}] toggleSelection: Before toggle, selectedResidents for field =`, JSON.stringify((this.formViewModel.selectedResidents()[this.fieldName] || []).map(s => s.id)));
            this.formViewModel.toggleResidentSelection(this.fieldName, resident);
            console.log(`[RMS-DEBUG][${this.fieldName}] toggleSelection: After toggle, selectedResidents for field =`, JSON.stringify((this.formViewModel.selectedResidents()[this.fieldName] || []).map(s => s.id)));
        };
        // Add a custom entry
        this.addCustomEntry = () => {
            const val = this.customValue().trim();
            console.log(`[RMS-DEBUG][${this.fieldName}] addCustomEntry: Called with customValue="${val}"`);
            if (val) {
                this.formViewModel.addCustomResident(this.fieldName, val);
                this.customValue(""); // Clear input after adding
                console.log(`[RMS-DEBUG][${this.fieldName}] addCustomEntry: Custom entry added. customResidents for field =`, JSON.stringify((this.formViewModel.customResidents()[this.fieldName] || []).map(s => ({ id: s.id, name: s.name }))));
            }
        };
        // Apply selections and close — just delegates to closeModal which always applies
        this.applySelections = () => {
            console.log(`[RMS-DEBUG][${this.fieldName}] applySelections: "Übernehmen" button clicked, delegating to closeModal`);
            this.closeModal();
        };
        this.fieldName = params.fieldName;
        this.placeholder = params.placeholder || 'Bewohner auswählen';
        this.formViewModel = params.formViewModel;
        console.log(`[RMS-DEBUG][${this.fieldName}] ctor: Component created. placeholder="${this.placeholder}", formViewModel exists=${!!this.formViewModel}`);
        console.log(`[RMS-DEBUG][${this.fieldName}] ctor: Initial selectedResidents =`, JSON.stringify(this.formViewModel.selectedResidents()));
        console.log(`[RMS-DEBUG][${this.fieldName}] ctor: Initial customResidents =`, JSON.stringify(this.formViewModel.customResidents()));
        console.log(`[RMS-DEBUG][${this.fieldName}] ctor: Residents count =`, this.formViewModel.residents().length);
        // Observables
        this.customValue = ko.observable("");
        this.modalVisible = ko.observable(false);
        this.searchQuery = ko.observable("");
        // Grouped and filtered residents
        this.groupedFilteredResidents = ko.computed(() => {
            const residents = this.formViewModel.getFilteredResidentsForField(this.fieldName);
            const query = this.searchQuery().toLowerCase();
            console.log(`[RMS-DEBUG][${this.fieldName}] groupedFilteredResidents: recomputing. Total residents for field=${residents.length}, searchQuery="${query}"`);
            let filtered = residents;
            // 1. Filter by search query
            if (query.length > 0) {
                filtered = residents.filter(r => (r.name && r.name.toLowerCase().includes(query)) ||
                    (r.displayName && r.displayName.toLowerCase().includes(query)) ||
                    (r.unitName && r.unitName.toLowerCase().includes(query)) ||
                    (r.unitFloor && r.unitFloor.toLowerCase().includes(query)));
                console.log(`[RMS-DEBUG][${this.fieldName}] groupedFilteredResidents: After search filter, ${filtered.length} residents remain`);
            }
            // 2. Group by unitFloor
            const groups = {};
            const groupOrder = [];
            filtered.forEach(r => {
                const groupKey = r.unitFloor || "Sonstige";
                if (!groups[groupKey]) {
                    groups[groupKey] = [];
                    groupOrder.push(groupKey);
                }
                groups[groupKey].push(r);
            });
            // 3. Convert to array for view
            const result = groupOrder.map(key => ({
                groupName: key,
                residents: groups[key]
            }));
            console.log(`[RMS-DEBUG][${this.fieldName}] groupedFilteredResidents: ${result.length} groups, total filtered=${filtered.length}`);
            return result;
        });
        // Computed for displaying selection summary
        this.selectionSummary = ko.computed(() => {
            const allSelectedResidents = this.formViewModel.selectedResidents();
            const allCustomResidents = this.formViewModel.customResidents();
            const selections = allSelectedResidents[this.fieldName] || [];
            const customEntries = allCustomResidents[this.fieldName] || [];
            const allSelections = [...selections, ...customEntries];
            console.log(`[RMS-DEBUG][${this.fieldName}] selectionSummary: recomputing. selections=${selections.length}, customEntries=${customEntries.length}, total=${allSelections.length}`);
            console.log(`[RMS-DEBUG][${this.fieldName}] selectionSummary: selectedResidents keys=`, Object.keys(allSelectedResidents));
            console.log(`[RMS-DEBUG][${this.fieldName}] selectionSummary: selections detail=`, JSON.stringify(selections.map(s => ({ id: s.id, name: s.name, displayName: s.displayName }))));
            if (allSelections.length === 0) {
                console.log(`[RMS-DEBUG][${this.fieldName}] selectionSummary: No selections, returning placeholder="${this.placeholder}"`);
                return this.placeholder;
            }
            else if (allSelections.length === 1) {
                const result = allSelections[0].displayName || allSelections[0].name || "Ausgewählt";
                console.log(`[RMS-DEBUG][${this.fieldName}] selectionSummary: Single selection, returning "${result}"`);
                return result;
            }
            else {
                // Show count based on owner/tenant type
                const type = this.isOwnerField(this.fieldName) ? 'Eigentümer' : 'Mieter';
                const result = `${allSelections.length} ${type} ausgewählt`;
                console.log(`[RMS-DEBUG][${this.fieldName}] selectionSummary: Multiple selections, returning "${result}"`);
                return result;
            }
        });
        this.hasSelections = ko.computed(() => {
            const selections = this.formViewModel.selectedResidents()[this.fieldName] || [];
            const customEntries = this.formViewModel.customResidents()[this.fieldName] || [];
            const result = selections.length > 0 || customEntries.length > 0;
            console.log(`[RMS-DEBUG][${this.fieldName}] hasSelections: recomputing. selections=${selections.length}, customEntries=${customEntries.length}, result=${result}`);
            return result;
        });
    }
    isOwnerField(fieldName) {
        return fieldName.includes('Eigentümer');
    }
    /**
     * Internal method: writes current selection to the field value, closes modal, and
     * fetches contact details in the background.
     */
    _applyAndClose() {
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: ===== START =====`);
        // Get selected IDs before closing
        const allSelectedResidents = this.formViewModel.selectedResidents();
        const selections = allSelectedResidents[this.fieldName] || [];
        const customEntries = this.formViewModel.customResidents()[this.fieldName] || [];
        const ids = selections.map(r => r.id);
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: selections count=${selections.length}, ids=`, JSON.stringify(ids));
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: customEntries count=${customEntries.length}`);
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Full selectedResidents object keys=`, Object.keys(allSelectedResidents));
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: selections detail=`, JSON.stringify(selections.map(s => ({ id: s.id, name: s.name, displayName: s.displayName, email: s.email }))));
        // 1. Update UI immediately with current data
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Step 1 - calling updateResidentFieldValue (immediate)`);
        this.formViewModel.updateResidentFieldValue(this.fieldName);
        // 2. Close modal and reset search
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Step 2 - closing modal and resetting search`);
        this.modalVisible(false);
        this.searchQuery("");
        // Verify state after close
        const postCloseSelections = this.formViewModel.selectedResidents()[this.fieldName] || [];
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Post-close verification: selections count=${postCloseSelections.length}`);
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: selectionSummary is now="${this.selectionSummary()}"`);
        console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: hasSelections is now=${this.hasSelections()}`);
        // Check the incidentField value
        const field = this.formViewModel.incidentFields().find((f) => f.name === this.fieldName);
        if (field) {
            console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: incidentField value is now="${field.value()}"`);
        }
        else {
            console.warn(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: WARNING - incidentField NOT FOUND for fieldName="${this.fieldName}"! This means the field value will NOT be updated.`);
            console.warn(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Available incidentFields:`, this.formViewModel.incidentFields().map((f) => f.name));
        }
        // 3. Fetch details in background (if any selections)
        if (ids.length > 0) {
            console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Step 3 - fetching contact details for ${ids.length} residents`);
            this.formViewModel.fetchContactDetails(ids).then(() => {
                // 4. Update UI again with potentially new details (email, phone)
                console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Step 4 - fetchContactDetails resolved, calling updateResidentFieldValue again`);
                this.formViewModel.updateResidentFieldValue(this.fieldName);
                // Verify after async update
                const asyncField = this.formViewModel.incidentFields().find((f) => f.name === this.fieldName);
                console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: Post-async incidentField value="${asyncField ? asyncField.value() : 'FIELD NOT FOUND'}"`);
                console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: ===== END (async) =====`);
            });
        }
        else {
            console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: No selections, skipping fetchContactDetails`);
            console.log(`[RMS-DEBUG][${this.fieldName}] _applyAndClose: ===== END (sync) =====`);
        }
    }
}
// Register the component
ko.components.register('resident-multi-select', {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            return new ResidentMultiSelectViewModel(params);
        }
    },
    template: { element: 'resident-multi-select-template' }
});
// Export to ensure the file is included in the bundle
export default {};
